<template>
  <el-dialog
    title="选择被申请人"
    width="50%"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <!-- 选择机构数据 -->
    <div v-if="step > 1">
        <el-form  ref="form" :model="form"  inline>
        <el-form-item class="col1-1" v-if="selectItem.name">
          <el-alert :title="`已选择：${selectItem.name}`" :closable="false"></el-alert>
        </el-form-item>
        <el-form-item prop="searchValue" label="被申请人名称" class="col1-3">
          <el-input class="search-input" maxlength="50" style="width: 100%" v-model="form.searchValue" placeholder="请选择被申请人"></el-input>
        </el-form-item>
        <el-form-item class="col1-3">
          <el-button type="primary" @click="filiterAllList">搜索</el-button>

          <el-button @click="form.searchValue = '';list = allTreeData">重置</el-button>
          <el-button type="danger" @click="handleItem">确认</el-button>
        </el-form-item>

      </el-form>
      <div style="max-height: 500px; overflow-y: auto" v-loading="loading">
          <el-tree :data="list" :props="defaultProps">
            <div class="custom-tree-node" slot-scope="{ node, data }">
              <el-radio v-if="!data.childs" :label="data.id" v-model="radio">{{ node.label }}</el-radio>
              <span v-else>{{ node.label }}</span>
            </div>
          </el-tree>
      </div>
    </div>

    <!-- 步骤图数据 -->
    <div v-else style="height:600px;overflow-y:scroll">
      <img :src="`${path}respondent_tip.png`" alt="" srcset="">

    </div>
    <div style="text-align:right" slot="footer" v-if="step
     == 1">
        <el-button type="primary" style="text-align:right" @click="next">下一步</el-button>
      </div>
  </el-dialog>
</template>

<script>
import Api from '@api/api'
import antistop from '@/utils/antistop'
export default {
  name: "respondentList",
  data() {
    return {
      path:window.location.origin + window.location.pathname,
      dialogVisible: false,
      list: [],
      step: 1,
      radio: null,
      allTreeData: [],
      defaultProps: {
        children: 'childs',
        label: 'name'
      },
      loading: false,
      form: {
        searchValue: '',
      },
      selectItem: {} // 选择的当前数据
    }
  },
  watch: {
    radio: function (val) {
      const item = this.allDataSource.find(item => item.id == val)
      console.log(item)
      this.form.searchValue = item.name
    }
  },
  props: {
    allDataSource: {
      type: Array,
      default: () => []
    },
    istraffic: {
      type: 'String',
      default: () => ''
    },
  },
  methods: {
    // 点击下一步
    next(){
      this.step = this.step + 1
    },
    // 选择非标
    handleItem () {
      if(this.form.searchValue == ''){
        return this.$message.warning('请选择要使用的被申请人')
      }
      const dataItem = this.allDataSource.find(item => item.name == this.form.searchValue)
      if (dataItem) {
        this.$emit('selected', dataItem)
        return
      } else {
        return this.$message.warning('请选择要使用的被申请人')
      }
      // 被申请人只能选择导致以下判断用不到了 2025.02.10
      const ANTISTOP = antistop.AntiStop

      if (this.form.searchValue.includes(ANTISTOP.find(item => this.form.searchValue.includes(item)))) {
        this.$message({
          message: '被申请人填写有误，请重新选择或填写正确的被申请人信息',
          type: 'warning',
          duration: 4000
        })
      } else {
        this.$message({
          message: '被申请人可能不正确，如确认无误，请手动选择复议机关并提交',
          type: 'warning',
          duration: 4000
        })
        setTimeout(() => {
          this.$emit('inputed', this.form.searchValue)
        }, 2000)
      }
    },
    // 搜索内容
    filiterAllList () {
      this.loading = true
      if (!this.form.searchValue){
        this.list = this.allTreeData
        this.loading = false
      } else {
        let field = this.istraffic == 1 ? 'allTreeData' : 'allDataSource'
        this.list = this[field].filter(d => {
          return d.name.indexOf(this.form.searchValue) > -1
        })
        this.loading = false
      }
    },
    init () {
      this.form.searchValue = ''
      this.step = 1
      this.dialogVisible = true
      this.getAllDTree()
    },
    // 获取全部列表数据
    getAllDTree () {
      /// 根据父组件是否交通处罚拼接参数 如果是 == 1 则拼接给后台"交通警察"四个字 用于过滤查询数据
      let filter = {
        name: this.istraffic == '1' ? '交通警察,交通管理' : ''
      }
      Api.getEntrustingAllDepartTree({
        ...filter
      }).then(({ data }) => {
        this.allTreeData = data.code == 0 ? data.data : [] // 获取的全部tree数据
        this.list = data.code == 0 ? data.data : []
      })
    },
    handleClose () {
      this.dialogVisible = false
      this.selectItem = {}
    }
  }
}
</script>

<style scoped>

</style>
